var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _text, _text2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path12, _text3, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeforeSleep(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 180 Q115 200 130 210 Q145 218 160 210 L160 180 Q140 188 120 180 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.8,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 192,
    r: 3,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 192,
    r: 3,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95 175 L95 210 Q95 220 105 220 L175 220 Q185 220 185 210 L185 175",
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80 175 Q140 165 200 175",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145 165 Q155 140 160 115 Q163 95 158 80",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155 160 Q170 130 180 105 Q188 85 195 65",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135 168 Q138 145 135 120 Q132 100 128 80",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5,
    strokeLinecap: "round",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165 158 Q180 135 200 115 Q215 100 225 75",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125 170 Q115 150 105 130 Q98 115 95 95",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.35,
    strokeLinecap: "round",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150 55 Q155 50 160 55 Q165 50 170 55",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190 50 Q195 45 200 50",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M115 65 Q120 60 125 65",
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 230,
    y: 70,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.5
  }, "...")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 95,
    y: 60,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 10,
    opacity: 0.4
  }, "?")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 60,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 75,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 85,
    r: 2,
    fill: "#38bdf8",
    opacity: 0.3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 90,
    r: 1.5,
    fill: "#fafcfb",
    opacity: 0.3
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 55,
    r: 1,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 75,
    r: 1,
    fill: "#38bdf8",
    opacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M280 160 L295 155 M285 170 L300 168 M290 180 L305 178",
    stroke: "#fafcfb",
    strokeWidth: 1,
    strokeOpacity: 0.2,
    strokeLinecap: "round"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 195,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    opacity: 0.3
  }, "z z z")), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 240,
    rx: 60,
    ry: 10,
    stroke: "#38bdf8",
    strokeOpacity: 0.12,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeforeSleep);
export default __webpack_public_path__ + "static/media/before-sleep.f98c4a73805b8a5289af1f08766618ea.svg";
export { ForwardRef as ReactComponent };